/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PodcastUploadStatusQueryVariables = {||};
export type PodcastUploadStatusQueryResponse = {|
  +recentPodcastUploads: ?$ReadOnlyArray<?{|
    +id: string,
    +title: string,
    +taskResult: ?{|
      +dateCreated: any
    |},
    +taskStateSummary: ?string,
  |}>
|};
export type PodcastUploadStatusQuery = {|
  variables: PodcastUploadStatusQueryVariables,
  response: PodcastUploadStatusQueryResponse,
|};
*/


/*
query PodcastUploadStatusQuery {
  recentPodcastUploads {
    id
    title
    taskResult {
      dateCreated
      id
    }
    taskStateSummary
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateCreated",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskStateSummary",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PodcastUploadStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PodcastUploadTaskType",
        "kind": "LinkedField",
        "name": "recentPodcastUploads",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CeleryTaskResultType",
            "kind": "LinkedField",
            "name": "taskResult",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PodcastUploadStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PodcastUploadTaskType",
        "kind": "LinkedField",
        "name": "recentPodcastUploads",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CeleryTaskResultType",
            "kind": "LinkedField",
            "name": "taskResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b4c20f18b3093cc38b995812fcafafd",
    "id": null,
    "metadata": {},
    "name": "PodcastUploadStatusQuery",
    "operationKind": "query",
    "text": "query PodcastUploadStatusQuery {\n  recentPodcastUploads {\n    id\n    title\n    taskResult {\n      dateCreated\n      id\n    }\n    taskStateSummary\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '761aa9af7e919080de8b2f405525cdd4';

module.exports = node;
